import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import type { AuthorizationRequest } from '../types/domain';

const AUTHORIZATIONS_KEY = ['authorizations'] as const;

export function useAuthorizationsList(status: string = 'Pending') {
  return useQuery({
    queryKey: [...AUTHORIZATIONS_KEY, 'list', status],
    queryFn: () => api.get<AuthorizationRequest[]>(`/api/v1/authorizations?status=${encodeURIComponent(status)}`),
  });
}

export function useDecideAuthorization() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, decision, comment }: { id: number; decision: 'Approved' | 'Rejected'; comment?: string }) =>
      api.post<AuthorizationRequest>(`/api/v1/authorizations/${id}/decide`, { decision, comment }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: AUTHORIZATIONS_KEY });
      qc.invalidateQueries({ queryKey: ['tickets'] });
    },
  });
}
